import { INITIALIZE_FORM } from '../actionTypes';
import { rejectFormActions } from '../reducer';

export default (values) => rejectFormActions[INITIALIZE_FORM](values);
